<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <RefundsTabs></RefundsTabs>
        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :title="`${$t('pages.ref_return_by_month')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import API from '@/api/API'
  import Storage from '@/api/Storage'
  import { map } from 'lodash'
  import Helper from '@/api/Helper'
  import TypeColor from '@/assets/TypeColor'
  import StatisticTable from '@/components/StatisticTable.vue'
  import RefundsTabs from './RefundsTabs.vue'

  export default {
    name: 'CancelByMonth',
    components: {
      Filters,
      StatisticTable,
      RefundsTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          courierFilter: true,
          byWmFilter: true,
          byWebmasterFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.canceled'), field: 'refunds_id'}
        ],
        rows: [],
        footColumns: {},
        EnMessage: [
          {id: 0, text: 'Без причины'},

          // Valid
          {id: 2, text: 'Дорого'},
          {id: 3, text: 'Передумал'},
          {id: 4, text: 'Не устраивает способ оплаты (карта/наличные)'},
          {id: 9, text: 'Плохая репутация продукта/компании'},
          {id: 10, text: 'Не нравится форма выпуска продукта (клиент выслушал оператора и ему не нравится форма выпуска)'},
          {id: 11, text: 'Клиент хочет получить информацию о гарантиях и возврате денег'},
          {id: 12, text: 'Медицинские противопоказания'},
          {id: 14, text: 'Муж, жена, родственники не разрешают'},
          {id: 16, text: 'Сделали заявку чтобы получить консультацию'},
          {id: 23, text: 'Заказы не могут быть обработаны в данный момент. (зп в след месяце, клиент в другом городе)'},
          {id: 24, text: 'Дорогая доставка'},
          {id: 27, text: 'Не хочет платить налог'},

          // Invalid
          {id: 1, text: 'Не заказывал'},
          {id: 5, text: 'Не успеваем доставить вовремя'},
          {id: 6, text: 'Уже купил'},
          {id: 7, text: 'Отвечает третье лицо, нет заказчика рядом'},
          {id: 8, text: 'На сайте другая цена'},
          // {id: 13, text: 'На сайте другая цена (не видел цену на сайте)'},
          {id: 15, text: 'Клиент думал что выиграл подарок (или бесплатную упаковку)'},
          {id: 17, text: 'Языковой барьер'},
          {id: 18, text: 'Не верный номер, не туда попали'},
          {id: 19, text: 'Недозвон в течении долгого времени'},
          {id: 20, text: 'Клиент скидывает звонок / не может быть подтвержден'},
          {id: 21, text: 'Не идёт на контакт бросает трубку агрессивно реагирует'},
          {id: 22, text: 'Клиенты молчат и не разговаривают'},
          {id: 25, text: 'Нет покрытия'},
          {id: 26, text: 'Клиент в черном списке'},
          {id: 28, text: 'Клиент младше 18 лет'},
          {id: 99, text: 'Другое'}
        ]
      }
    },

    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },

    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        this.headColumns = [
          {label: this.$root.$t('statistic.refundsId'), field: 'refunds_id'},
          {label: this.$root.$t('statistic.return'), field: 'refunds_id'}
        ]
        let language = Storage.language

        API.getReturnReasonStatisticByMonth(1).then(response => {
          let reasonsByMonth = []
          let footColumn = {
            reason_id: {
              value: ''
            },
            reason: {
              value: ''
            }
          }

          map(response.body, (year) => {
            map(year, (data, month) => {
              this.headColumns.push({
                label: this.$root.$t('month.' + month) + ' ' + Helper.percents(data.orders_count, data.reasons_count), field: 'month' + month, colspan: 2, bg: true
              })

              footColumn['month.' + month] = {
                value: data.reasons_count + ' / ' + data.orders_count, colspan: 2
              }

              map(data.reasons, (reason, reasonsId) => {
                if (reasonsByMonth[reasonsId] === undefined) reasonsByMonth[reasonsId] = {}

                reasonsByMonth[reasonsId]['m' + month] = reason
                reasonsByMonth[reasonsId]['m' + month].reasons_count = data.reasons_count
              })
            })
          })

          reasonsByMonth.forEach((reasonData, reasonId) => {
            let row = {
              reason_id: {value: reasonId},
              reason: {value: reasonId, style: {textAlign: 'left'}}
            }

            map(reasonData, (monthData, monthId) => {
              row.reason.value = language === 'ru' ? Helper.getCancelName(this.EnMessage, reasonId) : monthData.text
              row['month_count_' + monthId] = {}
              row['month_persent_' + monthId] = {}
              row['month_count_' + monthId] = {
                value: monthData.count
              }

              row['month_persent_' + monthId] = {
                value: Helper.percents(monthData.reasons_count, monthData.count),
                bgg: parseFloat(parseFloat(monthData.count) / parseFloat(monthData.reasons_count) * 100).toFixed(1),
                bggc: '#90caf9'
              }
            })

            this.rows.push(row)
          })

          console.log(this.rows)

          const reasonsArr = []

          if (this.rows.length) {
            this.EnMessage.forEach(reason => {
              const { id, text } = reason

              const relatedReason = this.rows.find(row => row.reason_id.value === id)
              console.log(relatedReason)
              if (relatedReason) reasonsArr.push(relatedReason)
            })
          }

          this.rows = reasonsArr

          this.footColumns = footColumn
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          console.log('err')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CancelByMonth.vue?52b8d0dc